const initialState = {
    salutation: "",
    firstName: "",
    surname: "",
    email: "",
    land: "",
    street: "",
    near: "",
    plz: "",
    ort: "",
    telephone: "",
    message: "",
};

export default function contactReducer(state = initialState, action) {
    
    switch (action.type) {

        case "salutation":
            return {
                ...state,
                salutation: action.payload
            };

        case "firstName":
            return {
                ...state,
                firstName: action.payload
            };

        case "surname":
            return {
                ...state,
                surname: action.payload
            };

        case "email":
            return {
                ...state,
                email: action.payload
            };

        case "land":
            return {
                ...state,
                land: action.payload
            };

        case "street":
            return {
                ...state,
                street: action.payload
            };

        case "near":
            return {
                ...state,
                near: action.payload
            };

        case "plz":
            return {
                ...state,
                plz: action.payload
            };

        case "ort":
            return {
                ...state,
                ort: action.payload
            };
        
        case "telephone":
            return {
                ...state,
                telephone: action.payload
            };

        case "message":
            return {
                ...state,
                message: action.payload
            };

        default:
            return state;
    }
}